import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NotificationService } from '../services/notification-service.service';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { MessageService } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { getStatusColor, getStatusLabel, getTouchpointStatusColor, ScheduleResponse, StatusColor } from '../model/notification-model';

@Component({
  selector: 'app-notification-details',
  templateUrl: './notification-details.component.html',
  styleUrls: ['./notification-details.component.css']
})
export class NotificationDetailsComponent implements OnInit {

  // --- Input ---
  @Input() notificationClusters: any[] = [];
  @Input() searchedClusters: any[] = [];
  @Input() fatherNotification: any;

  @Input() scheduleResponse: ScheduleResponse = null;

  @Output() refreshNotificationList = new EventEmitter<any>();
  // --- State ---
  displayDeleteDialog: boolean = false;
  menuCreationActive: boolean = false;
  notificationToDelete: any = null;


  StatusColor = StatusColor;
getStatusColor = getStatusColor;
getStatusLabel = getStatusLabel;
getTouchpointStatusColor = getTouchpointStatusColor;
  // --- Calendar service (adatta all'inject del tuo progetto) ---
  constructor(private notitificationService: NotificationService,
        public srvCalendar: CalendarTranslateService,
        private srvTranslate: TranslateService,
        private srvMessage: MessageService,

    ) {

    }


  ngOnInit(): void {

    console.log(this.scheduleResponse)
  }

  toggleMenu(id: number, index: number): void {
    this.notificationClusters = this.notificationClusters.map((n, i) => ({
      ...n,
      menuActivated: i === index ? !n.menuActivated : false
    }));
  }

  checkExpiredNotification(): string {
    // Logica CSS class per notifiche scadute
    return '';
  }

  onCheckEndNotification(): boolean {
    // Ritorna true se il bottone "crea" va disabilitato
    return false;
  }

  onSearchClusterToAdd(): void {
    this.menuCreationActive = true;
  }

  onDeleteNotification(notification: any, index: number): void {
    this.notificationToDelete = notification;
    this.displayDeleteDialog = true;
  }

  onDefinitiveDelete(notification: any): void {
    // Chiamata al service per eliminazione
    this.closePopupDelete();
  }

  closePopupDelete(): void {
    this.displayDeleteDialog = false;
    this.notificationToDelete = null;
  }

  onNotificationSelected(event: any): void {
    // Gestione selezione cluster
  }

  onClickAnnulla_ModalNotification(): void {
    this.menuCreationActive = false;
  }

  closeAddPopupAndRefresh(): void {
    this.menuCreationActive = false;
    // Eventuale refresh lista
  }
}


// WEBPACK FOOTER //
// ./src/app/views/notification/notification-detail/notification-details.component.ts